import { useState } from 'react';

export const useFormErrors = () => {
  const [errors, setErrors] = useState({
    clearError: (name) => {
      setErrors((prev) => ({
        ...prev,
        errors: (() => {
          const prevErrors = prev?.errors ?? {};
          const filteredErrors = {};
          for (const key in prevErrors) if (key !== name) filteredErrors[key] = prevErrors[key];
          return filteredErrors;
        })(),
      }));
    },
  });

  const addNewError = (errorData) => {
    setErrors((prev) => ({
      ...prev,
      errors: {
        ...(prev.errors ?? {}),
        ...errorData,
      },
    }));
  };

  return [errors, addNewError];
};
